import { Component, Inject, Input } from '@angular/core';
import { componentStylesByTheme } from '../utils/theme.utils';
import { THEME_TOKEN, Theme } from '../types/theme.types';
import { spinnerStylesSAG, spinnerStylesSHS } from './spinner.styles';

@Component({
  selector: 'sag-ui-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  /**
   * The size of the spinner.
   * @default 'md'
   * @type {'sm' | 'md' | 'lg'}
   * @optional
   */
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  protected circleSizes = {
    sm: {
      cx: 8,
      cy: 8,
      r: 7,
    },
    md: {
      cx: 10,
      cy: 10,
      r: 9,
    },
    lg: {
      cx: 20,
      cy: 20,
      r: 18,
    },
  };

  constructor(@Inject(THEME_TOKEN) private readonly theme: Theme) {}

  protected get classes(): string {
    return `sag-ui-spinner-${this.size}`;
  }

  protected get circleClasses(): string {
    const spinnerStyles = componentStylesByTheme(
      this.theme,
      spinnerStylesSAG,
      spinnerStylesSHS
    );

    return spinnerStyles();
  }
}
